export const currentSchoolSelector = (state: any) => state.currentSchool;
